import { render, staticRenderFns } from "./OpcionaisDeVeiculos.vue?vue&type=template&id=7eb5446b&"
import script from "./OpcionaisDeVeiculos.vue?vue&type=script&lang=js&"
export * from "./OpcionaisDeVeiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports